/**
 * Random display-name generator for guest sessions.
 *
 * Picks one adjective + one noun and concatenates in CamelCase. Word lists
 * are intentionally short and PG so the output is always recognizable and
 * tabular without being weirdly long. Output examples:
 *
 *   "BraveOtter", "RoyalChinchilla", "NimbleFox".
 *
 * No randomness source assumptions beyond Math.random.
 */

const ADJECTIVES: readonly string[] = [
  "Brave",
  "Royal",
  "Nimble",
  "Silent",
  "Mighty",
  "Sly",
  "Cosmic",
  "Lunar",
  "Solar",
  "Stormy",
  "Crimson",
  "Golden",
  "Velvet",
  "Iron",
  "Frosty",
  "Wild",
  "Lucky",
  "Wicked",
  "Witty",
  "Jolly",
  "Zesty",
  "Glitchy",
  "Plucky",
  "Rowdy",
  "Hyper",
  "Mellow",
  "Neon",
  "Pixel",
  "Quantum",
  "Shadow",
];

const NOUNS: readonly string[] = [
  "Otter",
  "Chinchilla",
  "Fox",
  "Falcon",
  "Wolf",
  "Tiger",
  "Lynx",
  "Bear",
  "Hawk",
  "Raven",
  "Yak",
  "Moose",
  "Badger",
  "Panda",
  "Cobra",
  "Heron",
  "Mantis",
  "Newt",
  "Squid",
  "Octopus",
  "Goblin",
  "Wizard",
  "Knight",
  "Bandit",
  "Phantom",
  "Comet",
  "Rocket",
  "Glider",
  "Drifter",
  "Nomad",
];

function pick<T>(arr: readonly T[]): T {
  const i = Math.floor(Math.random() * arr.length);
  return arr[i] as T;
}

/** Returns a random "AdjectiveNoun" pair, e.g. "BraveOtter". */
export function randomDisplayName(): string {
  return `${pick(ADJECTIVES)}${pick(NOUNS)}`;
}
